module.exports = "../static/media/icon_facebook.e4141768.png";